<header class="eventheader">
  <bau365-breadcrumb [breadcrumbElements]="breadcrumbElements"></bau365-breadcrumb>
  @if (exhibitor?.mood_image?.resource) {
  <div
    class="eventheader__moodimage"
    [style]="
      'background-image: url(\'' +
      (event?.mood_image?.resource ?? exhibitor?.mood_image?.resource | ImageUrl : event?.mood_image?.provider ?? exhibitor?.mood_image?.provider : {
        width: 1920,
        height: 1080,
        fileType: ImageFileTypes.WEBP,
      }) +
      '\')'
    "></div>
  } @if (!exhibitor?.mood_image?.resource) {
  <div
    class="eventheader__moodimage eventheader__moodimage--placeholder"
    [style]="'background-image: url(\'assets/230511_BAU-Insights_1240x310_Moodbild_V1.webp\')'"></div>
  }
  <section class="eventheader__overlay">
    <div class="mdc-layout-grid">
      <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          <section class="pre-headline">
            <div class="eventheader__summarywrapper">
              @if (event?.starts_at) {
              <div class="eventheader__date">
                <div class="eventheader__datecontent">
                  {{ event?.starts_at | date : 'd' : timezone }}<br />
                  {{ event?.starts_at | date : 'MMM' : timezone }}
                </div>
              </div>
              }
              <div class="eventheader__summary">
                <a [routerLink]="['/fairs', event?.fair_id, 'exhibitors', event?.exhibitor_id]">{{
                  exhibitor?.name
                }}</a>
                <h1 class="eventheader__headline mat-headline-1">{{ event?.headline }}</h1>
              </div>
            </div>
            <div class="topnavi__actions">
              <button mat-icon-button class="eventheader__action" (click)="openShareButtonDialog($event)">
                <mat-icon class="eventheader__actionicon">share</mat-icon>
              </button>
              <bau365-toggle-watchlist-item
                entityType="EVENT"
                [iconOnly]="true"
                [entityId]="event?.id"
                [pageContext]="'event-details'"
                [fairId]="event?.fair_id"></bau365-toggle-watchlist-item>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</header>
<ng-template #shareButtonsTitle>
  <span i18n="@@featureEventDetails-socialShareTitle">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="socialShareUrl"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareButtonClicked)="shareButtonClick($event)"></planone-share-buttons>
</ng-template>
